import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // General
    appName: 'NT',
    search: 'Rechercher',
    searchPlaceholder: 'Rechercher par nom de produit, modèle ou code-barres...',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    actions: 'Actions',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    currency: 'DA',
    
    // Settings & System
    settings: 'Paramètres',
    systemSettings: 'Paramètres système',
    factoryReset: 'Réinitialisation usine',
    factoryResetConfirm: 'Êtes-vous sûr ? Toutes les données seront supprimées !',
    factoryResetCode: 'Entrez le code de confirmation',
    factoryResetSuccess: 'Réinitialisation usine terminée',
    dataWillBeDeleted: 'Les données suivantes seront supprimées :',
    resetConfirmCode: 'RESET-ALL-DATA',
    
    // Permissions
    permissions: 'Permissions',
    userPermissions: 'Permissions utilisateur',
    rolePermissions: 'Permissions du rôle',
    customPermissions: 'Permissions personnalisées',
    resetToDefault: 'Réinitialiser par défaut',
    viewPermission: 'Voir',
    addPermission: 'Ajouter',
    editPermission: 'Modifier',
    deletePermission: 'Supprimer',
    manager: 'Gérant',
    
    // Sidebar
    hideSidebar: 'Masquer la barre latérale',
    showSidebar: 'Afficher la barre latérale',
    collapseSidebar: 'Réduire le menu',
    expandSidebar: 'Agrandir le menu',
    
    // Barcode
    generateBarcode: 'Générer code-barres',
    generateSku: 'Générer SKU',
    barcodeGenerated: 'Code-barres généré',
    
    // Bulk Price Update
    bulkPriceUpdate: 'Mise à jour des prix en masse',
    priceUpdateType: 'Type de mise à jour',
    percentageChange: 'Pourcentage',
    fixedAmount: 'Montant fixe',
    setPrice: 'Définir le prix',
    priceField: 'Champ de prix',
    allPrices: 'Tous les prix',
    roundTo: 'Arrondir à',
    previewChanges: 'Aperçu des modifications',
    applyChanges: 'Appliquer les modifications',
    priceUpdated: 'Prix mis à jour',
    
    // Quick Add Family
    addNewFamily: 'Ajouter une nouvelle famille',
    quickAddFamily: 'Ajout rapide',
    
    // Auth
    login: 'Connexion',
    register: 'Inscription',
    logout: 'Déconnexion',
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',
    welcomeBack: 'Bienvenue',
    createAccount: 'Créer un compte',
    loginSubtitle: 'Connectez-vous pour gérer votre inventaire',
    registerSubtitle: 'Créez un compte pour commencer',
    noAccount: "Vous n'avez pas de compte ?",
    hasAccount: 'Vous avez déjà un compte ?',
    invalidCredentials: 'Email ou mot de passe invalide',
    registerAsAdmin: "S'inscrire comme Admin",
    
    // Navigation
    dashboard: 'Tableau de bord',
    products: 'Produits',
    addProduct: 'Ajouter produit',
    users: 'Utilisateurs',
    userManagement: 'Gestion des utilisateurs',
    customers: 'Clients',
    suppliers: 'Fournisseurs',
    sales: 'Ventes',
    pos: 'Point de vente',
    purchases: 'Achats',
    cashManagement: 'Gestion de caisse',
    reports: 'Rapports',
    notifications: 'Notifications',
    employees: 'Employés',
    debts: 'Dettes',
    
    // Dashboard
    totalProducts: 'Total produits',
    totalUsers: 'Total utilisateurs',
    totalCustomers: 'Total clients',
    totalSuppliers: 'Total fournisseurs',
    totalEmployees: 'Total employés',
    lowStock: 'Stock faible',
    recentProducts: 'Produits récents',
    quickStats: 'Statistiques rapides',
    todaySales: "Ventes du jour",
    totalCash: 'Total caisse',
    totalReceivables: 'Total créances',
    totalPayables: 'Total dettes',
    
    // Products
    productName: 'Nom du produit',
    productNameEn: 'Nom du produit (Français)',
    productNameAr: 'Nom du produit (Arabe)',
    description: 'Description',
    descriptionEn: 'Description (Français)',
    descriptionAr: 'Description (Arabe)',
    price: 'Prix',
    purchasePrice: "Prix d'achat",
    wholesalePrice: 'Prix de gros',
    retailPrice: 'Prix de détail',
    quantity: 'Quantité',
    imageUrl: "URL de l'image",
    barcode: 'Code-barres',
    compatibleModels: 'Modèles compatibles',
    compatibleModelsHelp: 'Entrez les modèles séparés par des virgules',
    addNewProduct: 'Ajouter un nouveau produit',
    editProduct: 'Modifier le produit',
    deleteProduct: 'Supprimer le produit',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ?',
    productAdded: 'Produit ajouté avec succès',
    productUpdated: 'Produit mis à jour avec succès',
    productDeleted: 'Produit supprimé avec succès',
    noProducts: 'Aucun produit trouvé',
    noProductsSubtitle: 'Ajoutez votre premier produit',
    viewDetails: 'Voir les détails',
    inStock: 'En stock',
    outOfStock: 'Rupture de stock',
    lowStockWarning: 'Stock faible',
    importExcel: 'Importer depuis Excel',
    exportExcel: 'Exporter vers Excel',
    importSuccess: 'Importation terminée',
    
    // Filters
    filterByModel: 'Filtrer par modèle',
    allModels: 'Tous les modèles',
    clearFilters: 'Effacer les filtres',
    
    // Low Stock & OCR
    lowStockAlerts: 'Alertes stock faible',
    lowStockThreshold: 'Seuil de stock faible',
    lowStockThresholdHelp: 'Alerte quand la quantité est inférieure à',
    extractFromImage: "Extraire de l'image",
    extractingModels: 'Extraction en cours...',
    modelsExtracted: 'Modèles extraits',
    ocrFailed: "Échec de l'extraction",
    supportedFormats: 'Formats: JPG, PNG, WEBP',
    
    // Customers & Suppliers
    addCustomer: 'Ajouter client',
    editCustomer: 'Modifier client',
    customerName: 'Nom du client',
    phone: 'Téléphone',
    address: 'Adresse',
    notes: 'Notes',
    totalPurchases: 'Total achats',
    balance: 'Solde',
    noCustomers: 'Aucun client trouvé',
    customerAdded: 'Client ajouté',
    customerUpdated: 'Client mis à jour',
    customerDeleted: 'Client supprimé',
    addSupplier: 'Ajouter fournisseur',
    editSupplier: 'Modifier fournisseur',
    supplierName: 'Nom du fournisseur',
    noSuppliers: 'Aucun fournisseur trouvé',
    supplierAdded: 'Fournisseur ajouté',
    supplierUpdated: 'Fournisseur mis à jour',
    supplierDeleted: 'Fournisseur supprimé',
    
    // POS / Sales
    newSale: 'Nouvelle vente',
    addToCart: 'Ajouter au panier',
    cart: 'Panier',
    emptyCart: 'Panier vide',
    subtotal: 'Sous-total',
    discount: 'Remise',
    total: 'Total',
    paidAmount: 'Montant payé',
    remaining: 'Restant',
    paymentMethod: 'Mode de paiement',
    cash: 'Espèces',
    bank: 'Banque',
    wallet: 'Portefeuille électronique',
    safe: 'Coffre',
    personalMoney: 'Argent personnel',
    completeSale: 'Finaliser la vente',
    printInvoice: 'Imprimer facture',
    saleCompleted: 'Vente effectuée',
    invoiceNumber: 'Numéro de facture',
    selectCustomer: 'Sélectionner client',
    walkInCustomer: 'Client de passage',
    scanBarcode: 'Scanner code-barres',
    returnSale: 'Retour vente',
    saleReturned: 'Vente retournée',
    newPurchase: 'Nouvel achat',
    selectSupplier: 'Sélectionner fournisseur',
    purchaseCompleted: 'Achat effectué',
    
    // Cash Management
    cashBox: 'Caisse',
    bankAccount: 'Compte bancaire',
    eWallet: 'Portefeuille électronique',
    transfer: 'Transfert',
    transferFunds: 'Transférer des fonds',
    fromBox: 'De',
    toBox: 'Vers',
    amount: 'Montant',
    transferCompleted: 'Transfert effectué',
    transactions: 'Transactions',
    income: 'Revenu',
    expense: 'Dépense',
    
    // Status
    paid: 'Payé',
    partial: 'Partiel',
    unpaid: 'Non payé',
    returned: 'Retourné',
    pending: 'En attente',
    overdue: 'En retard',
    
    // Employees
    addEmployee: 'Ajouter employé',
    editEmployee: 'Modifier employé',
    employeeName: "Nom de l'employé",
    position: 'Poste',
    salary: 'Salaire',
    hireDate: "Date d'embauche",
    commissionRate: 'Taux de commission',
    noEmployees: 'Aucun employé trouvé',
    employeeAdded: 'Employé ajouté',
    employeeUpdated: 'Employé mis à jour',
    employeeDeleted: 'Employé supprimé',
    attendance: 'Présence',
    recordAttendance: 'Enregistrer présence',
    present: 'Présent',
    absent: 'Absent',
    late: 'En retard',
    leave: 'Congé',
    advances: 'Avances',
    addAdvance: 'Ajouter avance',
    totalAdvances: 'Total avances',
    totalCommission: 'Total commissions',
    
    // Debts
    addDebt: 'Ajouter dette',
    receivables: 'Créances',
    payables: 'Dettes',
    dueDate: "Date d'échéance",
    debtAmount: 'Montant de la dette',
    payDebt: 'Payer la dette',
    debtPaid: 'Paiement enregistré',
    noDebts: 'Aucune dette trouvée',
    schedulePayment: 'Planifier paiement',
    
    // Reports
    salesChart: 'Graphique des ventes',
    topProducts: 'Meilleurs produits',
    topCustomers: 'Meilleurs clients',
    profitReport: 'Rapport de bénéfices',
    totalRevenue: 'Revenu total',
    totalCost: 'Coût total',
    grossProfit: 'Bénéfice brut',
    profitMargin: 'Marge bénéficiaire',
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    
    // Backup
    backup: 'Sauvegarde',
    createBackup: 'Créer une sauvegarde',
    backupCreated: 'Sauvegarde créée',
    
    // Notifications
    markAsRead: 'Marquer comme lu',
    markAllRead: 'Tout marquer comme lu',
    noNotifications: 'Aucune notification',
    restockAlert: 'Alerte réapprovisionnement',
    lowStockAlert: 'Alerte stock faible',
    
    // Errors
    error: 'Erreur',
    somethingWentWrong: "Une erreur s'est produite",
    tryAgain: 'Réessayer',
    notFound: 'Non trouvé',
    unauthorized: 'Non autorisé',
    forbidden: 'Accès refusé',
    
    // User Management
    allUsers: 'Tous les utilisateurs',
    userRole: 'Rôle',
    userEmail: 'Email',
    userName: 'Nom',
    changeRole: 'Changer le rôle',
    deleteUser: "Supprimer l'utilisateur",
    deleteUserConfirm: 'Supprimer cet utilisateur ?',
    userDeleted: 'Utilisateur supprimé',
    userUpdated: 'Utilisateur mis à jour',
    noUsers: 'Aucun utilisateur trouvé',
    adminRole: 'Admin',
    userRoleLabel: 'Utilisateur',
    cannotDeleteSelf: 'Impossible de vous supprimer',
    createdAt: 'Créé le',
    
    // Product Families
    productFamilies: 'Familles de produits',
    addFamily: 'Ajouter famille',
    editFamily: 'Modifier famille',
    familyName: 'Nom de la famille',
    familyNameEn: 'Nom de la famille (Français)',
    familyNameAr: 'Nom de la famille (Arabe)',
    parentFamily: 'Famille parente',
    noParent: 'Aucun (Famille principale)',
    familyAdded: 'Famille ajoutée',
    familyUpdated: 'Famille mise à jour',
    familyDeleted: 'Famille supprimée',
    noFamilies: 'Aucune famille trouvée',
    productCount: 'Nombre de produits',
    cannotDeleteFamilyWithProducts: 'Impossible de supprimer une famille avec des produits',
    cannotDeleteFamilyWithChildren: 'Impossible de supprimer une famille avec des sous-familles',
    selectFamily: 'Sélectionner famille',
    allFamilies: 'Toutes les familles',
    
    // API Keys
    apiKeys: 'Clés API',
    addApiKey: 'Ajouter clé API',
    keyName: 'Nom de la clé',
    keyType: 'Type de clé',
    internal: 'Interne',
    external: 'Externe',
    service: 'Service',
    endpointUrl: 'URL du service',
    read: 'Lecture',
    write: 'Écriture',
    keyValue: 'Valeur de la clé',
    secretValue: 'Clé secrète',
    keyPreview: 'Aperçu de la clé',
    generateKey: 'Générer clé',
    copyKey: 'Copier clé',
    keyCopied: 'Clé copiée',
    keyActive: 'Actif',
    keyInactive: 'Inactif',
    toggleKey: 'Basculer',
    lastUsed: 'Dernière utilisation',
    noApiKeys: 'Aucune clé API trouvée',
    apiKeyAdded: 'Clé API ajoutée',
    apiKeyDeleted: 'Clé API supprimée',
    
    // Recharge / Top-up
    recharge: 'Recharge',
    topUp: 'Recharger',
    mobileRecharge: 'Recharge mobile',
    operator: 'Opérateur',
    phoneNumber: 'Numéro de téléphone',
    rechargeType: 'Type de recharge',
    credit: 'Crédit',
    internet: 'Internet',
    flexy: 'Flexy',
    ussdCode: 'Code USSD',
    rechargeAmount: 'Montant de recharge',
    selectOperator: "Sélectionner l'opérateur",
    selectAmount: 'Sélectionner le montant',
    rechargeNow: 'Recharger maintenant',
    rechargeSuccess: 'Recharge effectuée',
    rechargeHistory: 'Historique des recharges',
    todayRecharges: 'Recharges du jour',
    totalProfit: 'Bénéfice total',
    noRecharges: 'Aucune recharge trouvée',
    copyUssd: 'Copier code USSD',
    ussdCopied: 'Code USSD copié',
    
    // Delivery
    delivery: 'Livraison',
    deliveryService: 'Service de livraison',
    withDelivery: 'Avec livraison',
    withoutDelivery: 'Sans livraison',
    deliveryAddress: 'Adresse de livraison',
    deliveryWilaya: 'Wilaya',
    deliveryCity: 'Ville/Commune',
    deliveryFee: 'Frais de livraison',
    homeDelivery: 'Livraison à domicile',
    officeDelivery: 'Livraison au bureau',
    selectWilaya: 'Sélectionner wilaya',
    
    // Credit Sale
    creditSale: 'Vente à crédit',
    sellOnCredit: 'Vendre à crédit',
    paymentType: 'Type de paiement',
    cashPayment: 'Paiement comptant',
    creditPayment: 'À crédit',
    partialPayment: 'Paiement partiel',
    customerDebt: 'Dette client',
    customerDebts: 'Dettes clients',
    totalDebt: 'Dette totale',
    debtHistory: 'Historique des dettes',
    noDebt: 'Aucune dette',
    addPayment: 'Ajouter paiement',
    viewDebts: 'Voir les dettes',
    customerRequired: 'Veuillez sélectionner un client pour la vente à crédit',
    
    // SMS Reminders
    smsReminders: 'Rappels SMS',
    sendReminder: 'Envoyer rappel',
    sendBulkReminder: 'Envoyer à tous',
    smsSettings: 'Paramètres SMS',
    smsLogs: 'Historique SMS',
    smsTemplate: 'Modèle de message',
    selectTemplate: 'Sélectionner modèle',
    customMessage: 'Message personnalisé',
    autoReminder: 'Rappel automatique',
    reminderFrequency: 'Fréquence de rappel',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    reminderDay: 'Jour de rappel',
    reminderTime: 'Heure de rappel',
    minDebtAmount: 'Montant minimum de dette',
    smsSent: 'SMS envoyé',
    smsFailed: 'Échec SMS',
    sendingReminders: 'Envoi des rappels...',
    remindersSent: 'Rappels envoyés avec succès',
    noCustomersSelected: 'Veuillez sélectionner des clients',
    smsProvider: 'Fournisseur SMS',
    providerMocked: 'Simulé (Non connecté)',
  },
  ar: {
    // General
    appName: 'NT',
    search: 'بحث',
    searchPlaceholder: 'ابحث باسم المنتج أو الموديل أو الباركود...',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    actions: 'الإجراءات',
    confirm: 'تأكيد',
    yes: 'نعم',
    no: 'لا',
    currency: 'دج',
    
    // Settings & System
    settings: 'الإعدادات',
    systemSettings: 'إعدادات النظام',
    factoryReset: 'إعادة ضبط المصنع',
    factoryResetConfirm: 'هل أنت متأكد؟ سيتم حذف جميع البيانات!',
    factoryResetCode: 'أدخل كود التأكيد',
    factoryResetSuccess: 'تم إعادة ضبط المصنع بنجاح',
    dataWillBeDeleted: 'سيتم حذف البيانات التالية:',
    resetConfirmCode: 'RESET-ALL-DATA',
    
    // Permissions
    permissions: 'الصلاحيات',
    userPermissions: 'صلاحيات المستخدم',
    rolePermissions: 'صلاحيات الدور',
    customPermissions: 'صلاحيات مخصصة',
    resetToDefault: 'إعادة للافتراضي',
    viewPermission: 'عرض',
    addPermission: 'إضافة',
    editPermission: 'تعديل',
    deletePermission: 'حذف',
    manager: 'مدير',
    
    // Sidebar
    hideSidebar: 'إخفاء القائمة',
    showSidebar: 'إظهار القائمة',
    collapseSidebar: 'طي القائمة',
    expandSidebar: 'توسيع القائمة',
    
    // Barcode
    generateBarcode: 'توليد باركود',
    generateSku: 'توليد SKU',
    barcodeGenerated: 'تم توليد الباركود',
    
    // Bulk Price Update
    bulkPriceUpdate: 'تحديث الأسعار الجماعي',
    priceUpdateType: 'نوع التحديث',
    percentageChange: 'نسبة مئوية',
    fixedAmount: 'مبلغ ثابت',
    setPrice: 'تحديد قيمة',
    priceField: 'حقل السعر',
    allPrices: 'جميع الأسعار',
    roundTo: 'تقريب إلى',
    previewChanges: 'معاينة التغييرات',
    applyChanges: 'تطبيق التغييرات',
    priceUpdated: 'تم تحديث الأسعار',
    
    // Quick Add Family
    addNewFamily: 'إضافة عائلة جديدة',
    quickAddFamily: 'إضافة سريعة',
    
    // Auth
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    welcomeBack: 'مرحباً بعودتك',
    createAccount: 'إنشاء حساب جديد',
    loginSubtitle: 'سجل دخولك لإدارة المخزون',
    registerSubtitle: 'أنشئ حساباً للبدء',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب بالفعل؟',
    invalidCredentials: 'البريد أو كلمة المرور غير صحيحة',
    registerAsAdmin: 'التسجيل كمدير',
    
    // Navigation
    dashboard: 'لوحة التحكم',
    products: 'المنتجات',
    addProduct: 'إضافة منتج',
    users: 'المستخدمين',
    userManagement: 'إدارة المستخدمين',
    customers: 'الزبائن',
    suppliers: 'الموردين',
    sales: 'المبيعات',
    pos: 'نقطة البيع',
    purchases: 'المشتريات',
    cashManagement: 'إدارة المال',
    reports: 'التقارير',
    notifications: 'الإشعارات',
    employees: 'العمال',
    debts: 'الديون',
    
    // Dashboard
    totalProducts: 'إجمالي المنتجات',
    totalUsers: 'إجمالي المستخدمين',
    totalCustomers: 'إجمالي الزبائن',
    totalSuppliers: 'إجمالي الموردين',
    totalEmployees: 'إجمالي العمال',
    lowStock: 'مخزون منخفض',
    recentProducts: 'أحدث المنتجات',
    quickStats: 'إحصائيات سريعة',
    todaySales: 'مبيعات اليوم',
    totalCash: 'إجمالي النقد',
    totalReceivables: 'إجمالي المستحقات',
    totalPayables: 'إجمالي الديون',
    
    // Products
    productName: 'اسم المنتج',
    productNameEn: 'اسم المنتج (فرنسي)',
    productNameAr: 'اسم المنتج (عربي)',
    description: 'الوصف',
    descriptionEn: 'الوصف (فرنسي)',
    descriptionAr: 'الوصف (عربي)',
    price: 'السعر',
    purchasePrice: 'سعر الشراء',
    wholesalePrice: 'سعر الجملة',
    retailPrice: 'سعر التجزئة',
    quantity: 'الكمية',
    imageUrl: 'رابط الصورة',
    barcode: 'الباركود',
    compatibleModels: 'الموديلات المتوافقة',
    compatibleModelsHelp: 'أدخل الموديلات مفصولة بفواصل',
    addNewProduct: 'إضافة منتج جديد',
    editProduct: 'تعديل المنتج',
    deleteProduct: 'حذف المنتج',
    deleteConfirm: 'هل أنت متأكد من الحذف؟',
    productAdded: 'تمت إضافة المنتج',
    productUpdated: 'تم تحديث المنتج',
    productDeleted: 'تم حذف المنتج',
    noProducts: 'لا توجد منتجات',
    noProductsSubtitle: 'أضف أول منتج',
    viewDetails: 'عرض التفاصيل',
    inStock: 'متوفر',
    outOfStock: 'غير متوفر',
    lowStockWarning: 'مخزون منخفض',
    importExcel: 'استيراد من Excel',
    exportExcel: 'تصدير إلى Excel',
    importSuccess: 'تم الاستيراد بنجاح',
    
    // Filters
    filterByModel: 'تصفية حسب الموديل',
    allModels: 'جميع الموديلات',
    clearFilters: 'مسح الفلاتر',
    
    // Low Stock & OCR
    lowStockAlerts: 'تنبيهات المخزون المنخفض',
    lowStockThreshold: 'حد المخزون المنخفض',
    lowStockThresholdHelp: 'تنبيه عندما تقل الكمية عن هذا',
    extractFromImage: 'استخراج من صورة',
    extractingModels: 'جاري الاستخراج...',
    modelsExtracted: 'تم الاستخراج',
    ocrFailed: 'فشل الاستخراج',
    supportedFormats: 'الصيغ: JPG, PNG, WEBP',
    
    // Customers & Suppliers
    addCustomer: 'إضافة زبون',
    editCustomer: 'تعديل الزبون',
    customerName: 'اسم الزبون',
    phone: 'الهاتف',
    address: 'العنوان',
    notes: 'ملاحظات',
    totalPurchases: 'إجمالي المشتريات',
    balance: 'الرصيد',
    noCustomers: 'لا يوجد زبائن',
    customerAdded: 'تمت إضافة الزبون',
    customerUpdated: 'تم تحديث الزبون',
    customerDeleted: 'تم حذف الزبون',
    addSupplier: 'إضافة مورد',
    editSupplier: 'تعديل المورد',
    supplierName: 'اسم المورد',
    noSuppliers: 'لا يوجد موردين',
    supplierAdded: 'تمت إضافة المورد',
    supplierUpdated: 'تم تحديث المورد',
    supplierDeleted: 'تم حذف المورد',
    
    // POS / Sales
    newSale: 'بيع جديد',
    addToCart: 'أضف للسلة',
    cart: 'السلة',
    emptyCart: 'السلة فارغة',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    total: 'الإجمالي',
    paidAmount: 'المبلغ المدفوع',
    remaining: 'المتبقي',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقداً',
    bank: 'بنك',
    wallet: 'محفظة إلكترونية',
    safe: 'خزنة',
    personalMoney: 'مال خاص',
    completeSale: 'إتمام البيع',
    printInvoice: 'طباعة الفاتورة',
    saleCompleted: 'تم البيع',
    invoiceNumber: 'رقم الفاتورة',
    selectCustomer: 'اختر الزبون',
    walkInCustomer: 'عميل نقدي',
    scanBarcode: 'مسح الباركود',
    returnSale: 'إرجاع البيع',
    saleReturned: 'تم الإرجاع',
    newPurchase: 'شراء جديد',
    selectSupplier: 'اختر المورد',
    purchaseCompleted: 'تم الشراء',
    
    // Cash Management
    cashBox: 'الصندوق النقدي',
    bankAccount: 'الحساب البنكي',
    eWallet: 'المحفظة الإلكترونية',
    transfer: 'تحويل',
    transferFunds: 'تحويل أموال',
    fromBox: 'من',
    toBox: 'إلى',
    amount: 'المبلغ',
    transferCompleted: 'تم التحويل',
    transactions: 'الحركات المالية',
    income: 'دخل',
    expense: 'مصروف',
    
    // Status
    paid: 'مدفوع',
    partial: 'جزئي',
    unpaid: 'غير مدفوع',
    returned: 'مرتجع',
    pending: 'معلق',
    overdue: 'متأخر',
    
    // Employees
    addEmployee: 'إضافة عامل',
    editEmployee: 'تعديل العامل',
    employeeName: 'اسم العامل',
    position: 'المنصب',
    salary: 'الراتب',
    hireDate: 'تاريخ التوظيف',
    commissionRate: 'نسبة العمولة',
    noEmployees: 'لا يوجد عمال',
    employeeAdded: 'تمت إضافة العامل',
    employeeUpdated: 'تم تحديث العامل',
    employeeDeleted: 'تم حذف العامل',
    attendance: 'الحضور',
    recordAttendance: 'تسجيل الحضور',
    present: 'حاضر',
    absent: 'غائب',
    late: 'متأخر',
    leave: 'إجازة',
    advances: 'السلف',
    addAdvance: 'إضافة سلفة',
    totalAdvances: 'إجمالي السلف',
    totalCommission: 'إجمالي العمولات',
    
    // Debts
    addDebt: 'إضافة دين',
    receivables: 'مستحقات (ديون على الزبائن)',
    payables: 'ديون (للموردين)',
    dueDate: 'تاريخ الاستحقاق',
    debtAmount: 'مبلغ الدين',
    payDebt: 'سداد الدين',
    debtPaid: 'تم تسجيل السداد',
    noDebts: 'لا توجد ديون',
    schedulePayment: 'جدولة السداد',
    
    // Reports
    salesChart: 'مخطط المبيعات',
    topProducts: 'أفضل المنتجات',
    topCustomers: 'أفضل الزبائن',
    profitReport: 'تقرير الأرباح',
    totalRevenue: 'إجمالي الإيرادات',
    totalCost: 'إجمالي التكلفة',
    grossProfit: 'صافي الربح',
    profitMargin: 'هامش الربح',
    last7Days: 'آخر 7 أيام',
    last30Days: 'آخر 30 يوم',
    
    // Backup
    backup: 'النسخ الاحتياطي',
    createBackup: 'إنشاء نسخة احتياطية',
    backupCreated: 'تم إنشاء النسخة',
    
    // Notifications
    markAsRead: 'تحديد كمقروء',
    markAllRead: 'تحديد الكل كمقروء',
    noNotifications: 'لا توجد إشعارات',
    restockAlert: 'تنبيه إعادة تخزين',
    lowStockAlert: 'تنبيه مخزون منخفض',
    
    // Errors
    error: 'خطأ',
    somethingWentWrong: 'حدث خطأ ما',
    tryAgain: 'حاول مرة أخرى',
    notFound: 'غير موجود',
    unauthorized: 'غير مصرح',
    forbidden: 'الوصول مرفوض',
    
    // User Management
    allUsers: 'جميع المستخدمين',
    userRole: 'الدور',
    userEmail: 'البريد الإلكتروني',
    userName: 'الاسم',
    changeRole: 'تغيير الدور',
    deleteUser: 'حذف المستخدم',
    deleteUserConfirm: 'حذف هذا المستخدم؟',
    userDeleted: 'تم حذف المستخدم',
    userUpdated: 'تم تحديث المستخدم',
    noUsers: 'لا يوجد مستخدمين',
    adminRole: 'مدير',
    userRoleLabel: 'مستخدم',
    cannotDeleteSelf: 'لا يمكن حذف حسابك',
    createdAt: 'تاريخ الإنشاء',
    
    // Product Families
    productFamilies: 'عائلات المنتجات',
    addFamily: 'إضافة عائلة',
    editFamily: 'تعديل العائلة',
    familyName: 'اسم العائلة',
    familyNameEn: 'اسم العائلة (فرنسي)',
    familyNameAr: 'اسم العائلة (عربي)',
    parentFamily: 'العائلة الأم',
    noParent: 'بدون (عائلة رئيسية)',
    familyAdded: 'تمت إضافة العائلة',
    familyUpdated: 'تم تحديث العائلة',
    familyDeleted: 'تم حذف العائلة',
    noFamilies: 'لا توجد عائلات',
    productCount: 'عدد المنتجات',
    cannotDeleteFamilyWithProducts: 'لا يمكن حذف عائلة تحتوي منتجات',
    cannotDeleteFamilyWithChildren: 'لا يمكن حذف عائلة تحتوي عائلات فرعية',
    selectFamily: 'اختر العائلة',
    allFamilies: 'جميع العائلات',
    
    // API Keys
    apiKeys: 'مفاتيح API',
    addApiKey: 'إضافة مفتاح API',
    keyName: 'اسم المفتاح',
    keyType: 'نوع المفتاح',
    internal: 'داخلي',
    external: 'خارجي',
    service: 'الخدمة',
    endpointUrl: 'رابط الخدمة',
    read: 'قراءة',
    write: 'كتابة',
    keyValue: 'قيمة المفتاح',
    secretValue: 'المفتاح السري',
    keyPreview: 'معاينة المفتاح',
    generateKey: 'إنشاء مفتاح',
    copyKey: 'نسخ المفتاح',
    keyCopied: 'تم نسخ المفتاح',
    keyActive: 'نشط',
    keyInactive: 'غير نشط',
    toggleKey: 'تبديل الحالة',
    lastUsed: 'آخر استخدام',
    noApiKeys: 'لا توجد مفاتيح API',
    apiKeyAdded: 'تمت إضافة المفتاح',
    apiKeyDeleted: 'تم حذف المفتاح',
    
    // Recharge / Top-up
    recharge: 'شحن الرصيد',
    topUp: 'شحن',
    mobileRecharge: 'شحن رصيد الهاتف',
    operator: 'المشغل',
    phoneNumber: 'رقم الهاتف',
    rechargeType: 'نوع الشحن',
    credit: 'رصيد',
    internet: 'أنترنت',
    flexy: 'فليكسي',
    ussdCode: 'كود USSD',
    rechargeAmount: 'مبلغ الشحن',
    selectOperator: 'اختر المشغل',
    selectAmount: 'اختر المبلغ',
    rechargeNow: 'اشحن الآن',
    rechargeSuccess: 'تم الشحن بنجاح',
    rechargeHistory: 'سجل الشحن',
    todayRecharges: 'شحن اليوم',
    totalProfit: 'إجمالي الربح',
    noRecharges: 'لا توجد عمليات شحن',
    copyUssd: 'نسخ كود USSD',
    ussdCopied: 'تم نسخ الكود',
    
    // Delivery
    delivery: 'التوصيل',
    deliveryService: 'خدمة التوصيل',
    withDelivery: 'مع التوصيل',
    withoutDelivery: 'بدون توصيل',
    deliveryAddress: 'عنوان التوصيل',
    deliveryWilaya: 'الولاية',
    deliveryCity: 'البلدية/المدينة',
    deliveryFee: 'رسوم التوصيل',
    homeDelivery: 'توصيل للمنزل',
    officeDelivery: 'توصيل للمكتب',
    selectWilaya: 'اختر الولاية',
    
    // Credit Sale
    creditSale: 'البيع بالدين',
    sellOnCredit: 'بيع بالدين',
    paymentType: 'نوع الدفع',
    cashPayment: 'نقداً',
    creditPayment: 'دين',
    partialPayment: 'دفع جزئي',
    customerDebt: 'دين الزبون',
    customerDebts: 'ديون الزبائن',
    totalDebt: 'إجمالي الدين',
    debtHistory: 'سجل الديون',
    noDebt: 'لا يوجد دين',
    addPayment: 'إضافة دفعة',
    viewDebts: 'عرض الديون',
    customerRequired: 'يرجى اختيار زبون للبيع بالدين',
    
    // SMS Reminders
    smsReminders: 'تذكيرات SMS',
    sendReminder: 'إرسال تذكير',
    sendBulkReminder: 'إرسال للجميع',
    smsSettings: 'إعدادات SMS',
    smsLogs: 'سجل الرسائل',
    smsTemplate: 'قالب الرسالة',
    selectTemplate: 'اختر قالب',
    customMessage: 'رسالة مخصصة',
    autoReminder: 'تذكير تلقائي',
    reminderFrequency: 'تكرار التذكير',
    daily: 'يومي',
    weekly: 'أسبوعي',
    monthly: 'شهري',
    reminderDay: 'يوم التذكير',
    reminderTime: 'وقت التذكير',
    minDebtAmount: 'الحد الأدنى للدين',
    smsSent: 'تم الإرسال',
    smsFailed: 'فشل الإرسال',
    sendingReminders: 'جاري إرسال التذكيرات...',
    remindersSent: 'تم إرسال التذكيرات بنجاح',
    noCustomersSelected: 'يرجى اختيار الزبائن',
    smsProvider: 'مزود SMS',
    providerMocked: 'محاكاة (غير متصل)',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'ar');
  const isRTL = language === 'ar';
  const t = translations[language];
  
  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.body.dir = isRTL ? 'rtl' : 'ltr';
  }, [language, isRTL]); // eslint-disable-line react-hooks/exhaustive-deps
  
  const toggleLanguage = () => setLanguage(prev => prev === 'fr' ? 'ar' : 'fr');
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, isRTL, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};
